import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { useAllianceStore } from "../../hooks/useAllianceStore";
import { Alliance } from "../../types/slices/alliancesType";
import { CreateEditAllianceModal } from "./components/CreateEditAllianceModal";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";

const columns = [
  { type: "options", field: "options", label: "Opciones", align: "center" },
  { type: "text", field: "name", label: "NOMBRE", align: "center" },
  { type: "text", field: "description", label: "DESCRIPCIÓN", align: "start" },
  { type: "text", field: "type", label: "TIPO", align: "center" },
  {
    type: "image",
    field: "image",
    label: "IMAGEN",
    align: "center",
    format: (row) =>
      row.image ? <img src={row.image} alt="logo" width="50px" /> : "",
  },
  { type: "text", field: "order", label: "ORDEN", align: "center" },
  {
    type: "text",
    field: "status",
    label: "ESTADO",
    align: "center",
    format: (row) => (row.status ? "Activo" : "Inactivo"),
  },
];

const AlliancesView: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [rowSelected, setRowSelected] = useState<Alliance>({} as Alliance);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState<boolean>(false);

  const {
    alliances,
    statusAlliances,
    openModal,
    getAlliances,
    changeIsEdit,
    setEditAlliance,
    setOpenModal,
    setSelectedAlliance,
    deleteAlliance,
    getAlliancesSearch,
  } = useAllianceStore();

  useEffect(() => {
    setLoading(true);
    getAlliances().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAdd = () => {
    changeIsEdit(false);
    setOpenModal(true);
  };

  const onEdit = (rowSelected) => {
    changeIsEdit(true);
    const dataEdit = {
      id: rowSelected.id,
      name: rowSelected.name,
      description: rowSelected.description,
      regions: rowSelected.regions,
      region_id: rowSelected.region_id,
      type: rowSelected.type,
      logo: rowSelected.image,
      order: rowSelected.order,
      status: rowSelected.status,
    };
    setEditAlliance(dataEdit);
    setOpenModal(true);
  };

  const onDelete = (rowSelected) => {
    const dataDelete = {
      id: rowSelected.id,
      name: rowSelected.name,
      description: rowSelected.description,
      type: rowSelected.type,
      logo: rowSelected.image,
      order: rowSelected.order,
      status: rowSelected.status,
    };
    setRowSelected(dataDelete);
    setModalDeleteConfirm(true);
  };

  const onDeleteConfirm = async () => {
    const response = await deleteAlliance(rowSelected?.id || 0);
    if (response === true) {
      setSelectedAlliance({} as Alliance);
      setModalDeleteConfirm(false);
      getAlliances();
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onSearch = (value) => {
    if (value.length >= 1) {
      getAlliancesSearch(value);
    }
    if (value.length === 0) {
      getAlliances();
    }
  };

  return (
    <>
      {statusAlliances === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
      <Grid item xs={12}>
        <CustomTable
          title={"Alianzas"}
          columns={columns}
          loading={loading}
          rows={alliances || []}
          onRowClick={() => {}}
          hasOptions
          onAddFn={onAdd}
          onDelete={onDelete}
          onEdit={onEdit}
          onSearch={onSearch}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
      {modalDeleteConfirm && (
        <ModalConfirm
          open={modalDeleteConfirm}
          closeModal={() => {
            setModalDeleteConfirm(false);
          }}
          onCancel={() => {
            setModalDeleteConfirm(false);
          }}
          onConfirm={onDeleteConfirm}
          status={statusAlliances}
        />
      )}
      {openModal && <CreateEditAllianceModal />}
    </>
  );
};

export default AlliancesView;
